import React, { useState } from "react";

function CreditCard(props) {
  const [elementFontSize, setElementFontSize] = useState(
    window.innerWidth < 450 ? "14px" : "18px"
  );

  window.addEventListener("resize", () => {
    if (window.innerWidth < 450 && this.state.elementFontSize !== "14px") {
      setElementFontSize("14px");
    } else if (window.innerWidth >= 450 && elementFontSize !== "18px") {
      setElementFontSize("18px");
    }
  });

  return <div className="Checkout"></div>;
}
export default CreditCard;
